import { MARGIN_X_DEFAULT } from './common'
import { useMergeIsMobile } from '../providers/MergeLayoutProvider'

/** Mobile gives up the room around a Checkbox's -12px margin (MARGIN_X_DEFAULT) to fit more of each column */
export const MARGIN_X_MOBILE = 8

/** Side padding for merge cells and, at mobile, the page gutter that lines up with their text */
export default function useMergeMarginX(): number {
  const isMobile = useMergeIsMobile()
  if (isMobile) {
    return MARGIN_X_MOBILE
  }
  return MARGIN_X_DEFAULT
}
